import React from 'react';
import {useHistory} from 'react-router';
import Skeleton from '../../../ui/skeleton/Skeleton';
import UIContainer from '../../../ui/UIContainer';
import Avatar from '../../../ui/Avatar';
import TextButton from '../../../ui/TextButton';

type Props = {
  notFound?: boolean
}

export default function LicenseeProfileSkeleton({notFound}:Props) {
  const history = useHistory();

  return (
    <>
    <div className="bg-gray-light pb-10">
    <UIContainer>
      <TextButton className="text-left pl-0 mt-4" onClick={history.goBack}>&larr; Back</TextButton>
      <div className="flex mt-4">
        <Avatar name="stub" className="rounded-md w-28 h-28"/>
        <div className="flex flex-1 flex-col ml-4 justify-between">
          <Skeleton className="w-5/12 h-12"/>
          <div className="flex">
            <Skeleton className="w-1/12 h-6 mr-6"/>
            <Skeleton className="w-1/12 h-6 mr-6"/>
            <Skeleton className="w-2/12 h-6 mr-6"/>
            <Skeleton className="w-2/12 h-6 mr-6"/>
          </div>
          <Skeleton className="w-2/12 h-6"/>
        </div>
      </div>
    </UIContainer>
    </div>
    { notFound?
      <UIContainer className="py-10">
        <h2 className="text-4xl font-bold">Licensee not found</h2>
      </UIContainer> :
      <UIContainer className="pb-10">
        <Skeleton className="w-6/12 h-8 mt-6"/>
        <Skeleton className="w-4/12 h-6 mb-5 mt-2"/>
        <div className="bg-white overflow-hidden py-5 pt-3 flex">
          <div className="flex-grow">
            <div className="pb-5">
              <h3 className="text-2xl font-bold">Licensee info</h3>
            </div>
            <div className="">
              <dl>
                <div className="grid grid-cols-3 gap-4 py-2">
                  <dt className="text-gray-dark">Address</dt>
                  <dd className="col-span-2"><Skeleton/></dd>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </UIContainer>
    }
  </>
  );
}
